import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import TextInput from '@components/Form/TextInput'
import SelectInput from '@components/Form/SelectInput'
import LabeledToggle from '@components/Buttons/LabeledToggle'
import EditUserSubmit from '@components/EditUser/EditUserSubmit'
import { useButtonWidth } from '@services/layout'
import * as Utils from '@services/utils'
import { userTypes } from '@data/Users'
import { PageHeader, FormRow, SubmitWrapper } from '@appearance/styled'
import i18n from '@localization/i18n'

export const USER_STATUS_ACTIVE = 'פעיל'
export const USER_STATUS_SUSPENDED = 'מושהה'

export default ({}) => {
    const location = useLocation()
    const buttonWidth = useButtonWidth()
    const preEditUser = location.state ? location.state.user : null
    const [user, setUser] = useState(preEditUser)

    useEffect(() => {
        if (!user?.max_paralleled_orders && user?.dance_registered_limit) {
            const max_paralleled_orders = user.dance_registered_limit
            setUserProperty({ max_paralleled_orders })
        }
    }, [])

    const setUserProperty = (propertyObj) => {
        setUser(Object.assign({}, user, propertyObj))
    }

    const toggleIsAdmin = () => {
        setUserProperty({ is_admin: !user.is_admin })
    }

    const toggleIsSuspended = () => {
        setUserProperty({ is_suspended: !user.is_suspended })
    }

    if (!user) {
        return null
    }

    return (
        <Main>
            <PageHeader>{i18n.t('edit_user.headline')}</PageHeader>
            <FormContainer>
                <FormRow>
                    <TextInput
                        text={user.first_name}
                        label={i18n.t('edit_user.first_name')}
                        onChangeText={(first_name) =>
                            setUserProperty({ first_name })
                        }
                        width={buttonWidth}
                    />
                    <TextInput
                        text={user.last_name}
                        label={i18n.t('edit_user.last_name')}
                        onChangeText={(last_name) =>
                            setUserProperty({ last_name })
                        }
                        width={buttonWidth}
                    />
                    <TextInput
                        text={user.email}
                        label={i18n.t('edit_user.email')}
                        onChangeText={(email) => setUserProperty({ email })}
                        width={buttonWidth}
                    />
                </FormRow>

                <FormRow>
                    <TextInput
                        text={user.id_number || ''}
                        label={i18n.t('edit_user.id')}
                        type="number"
                        onChangeText={(id_number) =>
                            setUserProperty({ id_number })
                        }
                        width={buttonWidth}
                    />
                    <TextInput
                        text={user.cellular || ''}
                        label={i18n.t('edit_user.cell_number')}
                        type="number"
                        onChangeText={(cellular) =>
                            setUserProperty({ cellular })
                        }
                        width={buttonWidth}
                    />
                    <TextInput
                        text={user.phone_num || ''}
                        label={i18n.t('edit_user.another_phone')}
                        type="number"
                        onChangeText={(phone_num) =>
                            setUserProperty({ phone_num })
                        }
                        width={buttonWidth}
                    />
                </FormRow>

                <FormRow>
                    <TextInput
                        text={user.address || ''}
                        label={i18n.t('edit_user.address')}
                        onChangeText={(address) => setUserProperty({ address })}
                        width={'100%'}
                    />
                </FormRow>
                <FormRow>
                    <SelectInput
                        value={user.choreographer_type || ''}
                        label={i18n.t('edit_user.instructor_type')}
                        placeholder={i18n.t('edit_dance.select')}
                        onSelect={(choreographer_type) =>
                            setUserProperty({ choreographer_type })
                        }
                        options={userTypes}
                        onError={(error) =>
                            console.log('setUserType selectInput error', error)
                        }
                        required={false}
                        width={buttonWidth}
                    />
                    <TextInput
                        text={user.member_id || ''}
                        label={i18n.t('edit_user.membership_number')}
                        type="number"
                        onChangeText={(member_id) =>
                            setUserProperty({ member_id })
                        }
                        width={buttonWidth}
                    />
                    <SelectInput
                        value={user.max_paralleled_orders || ''}
                        label={i18n.t('edit_user.max_parallel_orders')}
                        placeholder={i18n.t('edit_dance.select')}
                        onSelect={(max_paralleled_orders) =>
                            setUserProperty({ max_paralleled_orders })
                        }
                        options={Utils.getArrayOfNum(50)}
                        onError={(error) =>
                            console.log(
                                'max_paralleled_orders selectInput error',
                                error
                            )
                        }
                        width={buttonWidth}
                    />
                </FormRow>

                <FormRow>
                    <LabeledToggle
                        value={!user.is_suspended}
                        onToggle={toggleIsSuspended}
                        label={i18n.t('edit_user.membership_paid')}
                        width={buttonWidth}
                    />
                    <LabeledToggle
                        value={user.is_admin || false}
                        onToggle={toggleIsAdmin}
                        label={i18n.t('edit_user.admin')}
                        width={buttonWidth}
                    />
                </FormRow>

                <SubmitWrapper>
                    <EditUserSubmit user={user} preEditUser={preEditUser} />
                </SubmitWrapper>
            </FormContainer>
        </Main>
    )
}

const Main = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`

const FormContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`
